import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#4C5B7F] to-[#2C3B5F] text-white antialiased font-sans scroll-smooth">
      <header className="max-w-6xl mx-auto px-6 py-8 flex items-center justify-between">
        <div className="font-bold text-lg">DeenLock</div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-6">Terms of Use</h1>

        <p className="text-white/80 mb-4">
          By downloading or using the DeenLock app, you agree to these Terms of Use. 
          Please read them carefully. If you do not agree, you may not use the app.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. App Usage</h2>
        <p className="text-white/80 mb-4">
          DeenLock is designed to help users manage personal device usage, 
          maintain daily Quran reading goals, and encourage productivity through 
          Barakah Mode. The app is intended for lawful, personal, and educational use only.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Parental Supervision</h2>
        <p className="text-white/80 mb-4">
          For children under 13 or individuals under parental guidance, 
          parents or guardians are responsible for supervising usage and 
          controlling app access. DeenLock provides features to support 
          parental control, but ultimate responsibility lies with the guardian.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Restrictions</h2>
        <p className="text-white/80 mb-4">
          Users may not use DeenLock to:
          <ul className="list-disc list-inside mt-2">
            <li>Track or collect personal information of others.</li>
            <li>Engage in any illegal activity.</li>
            <li>Attempt to modify, hack, or redistribute the app without permission.</li>
          </ul>
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Intellectual Property</h2>
        <p className="text-white/80 mb-4">
          All content, branding, and design within DeenLock are the property 
          of DeenLock. Users may not reproduce, distribute, or create derivative 
          works without express written consent.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. No Warranty</h2>
        <p className="text-white/80 mb-4">
          DeenLock is provided "as is" without warranty of any kind. We do not guarantee 
          uninterrupted service, accuracy of features, or suitability for any particular purpose. 
          Users use the app at their own risk.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. Limitation of Liability</h2>
        <p className="text-white/80 mb-4">
          DeenLock is not liable for any damages, including loss of data, 
          missed goals, or device issues. Parents/guardians remain responsible 
          for supervising children's app use.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Updates and Changes</h2>
        <p className="text-white/80 mb-4">
          We may update the app or these Terms of Use periodically. Continued 
          use of DeenLock constitutes acceptance of the updated terms. 
          The latest version will always be available in the app and on our website.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Contact Us</h2>
        <p className="text-white/80 mb-4">
          If you have any questions about these Terms of Use, you can reach us at{" "}
          <a
            href="mailto:deenlockapp@gmail.com"
            className="underline hover:text-[#FFD369]"
          >
            deenlockapp@gmail.com
          </a>.
        </p>
      </main>

      <footer className="border-t border-white/10 py-8 mt-20">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4 text-white/60">
          <div className="text-sm">
            © {new Date().getFullYear()} DeenLock — All rights reserved.
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm hover:text-white transition">
              Back to Home
            </Link>
            <a href="mailto:deenlockapp@gmail.com" className="text-sm hover:text-white transition">
              deenlockapp@gmail.com
            </a>
          </div>
        </div>
      </footer>

      <style>{`html { scroll-behavior: smooth; }`}</style>
    </div>
  );
}
